import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FC } from "react";

export interface staticSelect {
  id: string;
  value: string;
  setValue: Function;
  data: {
    label: string, value?: string
  }[];
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

const StaticDataSelect: FC<staticSelect> = ({ id, value, setValue, required, disabled = false, placeholder, data }) => {
  const handleChange = (selected: string) => {
    const fakeEvent = {
      currentTarget: {
        id,
        value: selected,
      },
    };

    setValue(fakeEvent);
  };

  return (
    <>
      <Select value={value} onValueChange={handleChange} disabled={disabled}>
        <SelectTrigger className="mt-1 w-full">
          <SelectValue placeholder={placeholder || "Select"} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>Select</SelectLabel>
            <div className="max-h-80 overflow-y-auto">
              {data &&
                data?.length > 0 &&
                data?.map((item) => {
                  return (
                    <SelectItem key={item.label} value={item.value || item.label}>
                      {item.label}
                    </SelectItem>
                  );
                })}
            </div>
          </SelectGroup>
        </SelectContent>
      </Select>
      <input
        id={id}
        name={id}
        type="text"
        value={value || ""}
        onChange={() => {}}
        required={required || false}
        className="absolute w-px h-px -m-px p-0 overflow-hidden clip-rect-0 border-0"
      />
    </>
  );
};

export default StaticDataSelect;
